import { Grid, IconButton, Tooltip } from '@material-ui/core';
import { Redo, Undo } from '@material-ui/icons';
import React from 'react';
import { CollectionChangeApi } from './change-api';

type UndoRedoProps = {
  api: CollectionChangeApi;
  tooltip?: string;
  htmlColor?: string;
  hide?: boolean;
  label?: string;
};

export function UndoRedo(props: UndoRedoProps) {
  const { htmlColor, api, label } = { ...{ htmlColor: 'white' }, ...props };

  const canUndo = api.data((s) => s.canUndo);
  const canRedo = api.data((s) => s.canRedo);

  const { undo, redo } = api.actions;

  //  console.log('l h', labels.length, changes.length)
  const style = (active: boolean) => (active ? undefined : { opacity: 0.4 });
  return (
    <Grid container direction="row" spacing={0}>
      <Grid item>
        <Tooltip title="Undo" placement="top">
          <IconButton disabled={!canUndo} onClick={undo} id="undo" data-field={label}>
            <Undo htmlColor={htmlColor} style={style(canUndo)} />
          </IconButton>
        </Tooltip>
      </Grid>
      <Grid item>
        <Tooltip title="Redo" placement="top">
          <IconButton disabled={!canRedo} onClick={redo} id="redo" data-field={label}>
            <Redo htmlColor={htmlColor} style={style(canRedo)} />
          </IconButton>
        </Tooltip>
      </Grid>
    </Grid>
  );
}
